module.exports = __webpack_public_path__ + "img/feature-04-team.5490b3e0.svg";